(function () {
  'use strict';

  if (window.__awUniversalGallerySlideInstalled) return;
  window.__awUniversalGallerySlideInstalled = true;

  function visibleThumbs(gallery) {
    return Array.from(gallery.querySelectorAll('[data-gallery-thumb]')).filter(function (thumb) {
      return !thumb.hidden;
    });
  }

  function activateFromArrow(gallery, direction) {
    var thumbs = visibleThumbs(gallery);
    if (!thumbs.length) return;

    var activeIndex = thumbs.findIndex(function (thumb) {
      return thumb.classList.contains('is-active');
    });

    if (activeIndex < 0) activeIndex = 0;

    var targetIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
    var target = thumbs[targetIndex];
    if (!target) return;

    if (target.hasAttribute('data-static-thumb')) {
      gallery.dataset.staticGallerySelected = 'true';
    } else {
      delete gallery.dataset.staticGallerySelected;
    }

    target.click();
  }

  document.addEventListener('click', function (event) {
    var next = event.target.closest('[data-gallery-main-next]');
    var previous = event.target.closest('[data-gallery-main-prev]');
    if (!next && !previous) return;

    var gallery = event.target.closest('[data-gallery]');
    if (!gallery) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    activateFromArrow(gallery, next ? 1 : -1);
  }, true);
})();
